/**
 * TanStack Query hooks for `starter-plan-single-client-basic-tracking-capped-clicks-convs`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys,
	type CreateStarterPlanSingleClientBasicTrackingCappedClicksConvsBody,
	type ListStarterPlanSingleClientBasicTrackingCappedClicksConvsResponse,
	type StarterPlanSingleClientBasicTrackingCappedClicksConvsRow,
} from "./api";

export function useStarterPlanSingleClientBasicTrackingCappedClicksConvsList(): UseQueryResult<ListStarterPlanSingleClientBasicTrackingCappedClicksConvsResponse, Error> {
	return useQuery({
		queryKey: starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys.list(),
		queryFn: list,
	});
}

export function useStarterPlanSingleClientBasicTrackingCappedClicksConvsCreate(): UseMutationResult<StarterPlanSingleClientBasicTrackingCappedClicksConvsRow, Error, CreateStarterPlanSingleClientBasicTrackingCappedClicksConvsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys.all });
		},
	});
}

export function useStarterPlanSingleClientBasicTrackingCappedClicksConvsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: starterPlanSingleClientBasicTrackingCappedClicksConvsQueryKeys.all });
		},
	});
}
